import { Reducer } from 'redux';
import { Ruleset } from 'entities/campaign';
import { Channel, EmailChannel, isOffSiteChannel } from 'entities/campaign/rulesets/channels';
import { GenericState } from 'services/genericAPIGatewayService';
import { getUpdatedEntity } from 'services/genericAPIGatewayService/ducks/selectors';
import { updateLocal } from 'services/genericAPIGatewayService/ducks/updatesReducer';
import { Action } from 'store';
import { Types } from './types';

export function rulesetReducer(
  baseReducer: Reducer,
): (state: GenericState<Ruleset>, action: Action) => GenericState<Ruleset> {
  return (state: GenericState<Ruleset>, action: Action): GenericState<Ruleset> => {
    switch (action.type) {
      case Types.CHANNEL_CHANGED: {
        const rulesetEntity = getUpdatedEntity(state, action.payload.rulesetId);
        const newChannel: Channel = {
          ...action.payload.channel,
        };
        const channels = [...rulesetEntity.channels];
        if (isOffSiteChannel(action.payload.channel)) {
          action.payload.channelIndex = getOffsiteChannelIndex(channels, action.payload.channel);
        }
        if (action.payload.channelIndex !== -1) {
          channels.splice(action.payload.channelIndex, 1, newChannel);
        }
        return {
          ...state,
          updates: updateLocal(state.updates, action.payload.rulesetId, {
            ...rulesetEntity,
            channels,
          }),
        };
      }
      case Types.CHANNEL_DELETED: {
        const rulesetEntity = getUpdatedEntity(state, action.payload.rulesetId);
        const channels = [...rulesetEntity.channels];
        if (action.payload.cycleId !== undefined && action.payload.cycleId !== '') {
          action.payload.channelIndex = getChannelIndexByCycleId(channels, action.payload.cycleId);
        }
        if (action.payload.channelIndex !== -1) {
          channels.splice(action.payload.channelIndex, 1);
        }

        return {
          ...state,
          updates: updateLocal(state.updates, action.payload.rulesetId, {
            ...rulesetEntity,
            channels,
          }),
        };
      }
      default:
        return baseReducer(state, action);
    }
  };
}

function getOffsiteChannelIndex(channels: Channel[], selectedChannel: Channel): number {
  const emailChannels = channels as EmailChannel[];
  const emailChannel = selectedChannel as EmailChannel;
  return emailChannels.findIndex(c => c.cycleId === emailChannel.cycleId);
}

function getChannelIndexByCycleId(channels: Channel[], cycleId: string): number {
  let channelIndex = -1;
  for (let i = 0; i < channels.length; i++) {
    if (isOffSiteChannel(channels[i])) {
      const emailChannel = channels[i] as EmailChannel;
      if (emailChannel.cycleId === cycleId) {
        channelIndex = i;
        break;
      }
    }
  }
  return channelIndex;
}
